//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { RecycleScroller } from 'vue-virtual-scroller';
import { clearTextSelection } from '@/helpers/util';
import TreeViewRow from './TreeViewRow.vue';

export default {
  name: 'DpTreeViewRows',
  components: {
    RecycleScroller,
    TreeViewRow,
  },
  props: {
    rows: { type: Array, default: () => [] },
    columns: { type: Array, default: null, required: true },
    selection: { type: Array, default: () => [] },
    locked: { type: Boolean, default: false },
    singleSelection: { type: Boolean, default: false },
  },
  data() {
    return {
      anchorRow: null,
    };
  },
  watch: {
    rows() {
      this.navigateToSelection();
    },
    selection() {
      this.navigateToSelection();
    },
  },
  mounted() {
    // a longer delay than nextTick is required:
    setTimeout(() => this.navigateToSelection(), 1000);
  },
  methods: {
    expandRow(row) {
      this.$set(row.$tableMeta, 'loading', true);
      this.$emit('expand', row);
    },
    contractRow(row) {
      this.$emit('contract', row);
    },
    selectDevice({ ev, index, device }) {
      if (this.singleSelection) {
        this.selectSingle(device, index);
        return;
      }

      const { shiftKey, metaKey, ctrlKey } = ev;
      if (!shiftKey && !metaKey && !ctrlKey) {
        this.toggleSelect(device, index);
        return;
      }

      if (ev.shiftKey) {
        clearTextSelection();
        this.selectBetween(this.anchorRow, index);
        return;
      }

      this.anchorRow = index;
      this.selectSingle(device, index);
    },
    toggleSelect(device, index) {
      const newSelection = [];
      if (!this.selection.includes(device)) {
        this.anchorRow = index;
        newSelection.push(device);
      } else {
        this.anchorRow = null;
      }
      this.$emit('change-selection', newSelection);
    },
    selectSingle(device, index) {
      const { selection } = this;
      let newSelection = [];
      if (selection.includes(device)) {
        newSelection = selection.filter((sel) => sel !== device);
      } else {
        this.anchorRow = index;

        if (this.singleSelection) {
          newSelection = [device];
        } else {
          newSelection = [...selection, device];
        }
      }

      // Clear anchor if no devices are selected
      if (newSelection.length === 0) {
        this.anchorRow = null;
      }

      this.$emit('change-selection', newSelection);
    },
    selectBetween(anchor, finalRow) {
      // If there is no current anchor then treat it as a single select
      if (anchor === null) {
        this.anchorRow = finalRow;
        this.$emit('change-selection', [this.rows[finalRow].$id]);
        return;
      }

      const selection = [];

      const start = anchor < finalRow ? anchor : finalRow;
      const end = anchor < finalRow ? finalRow : anchor;
      for (let i = start; i <= end; i += 1) {
        const row = this.rows[i];
        // Only add device rows
        if (!row.$tableMeta.hasChildren) {
          selection.push(row.$id);
        }
      }

      this.$emit('change-selection', selection);
    },
    navigateToSelection() {
      if (this.selection.length === 0 || !this.$refs.virtualList) return; // short circuit
      const [target] = this.selection;
      const index = this.rows.findIndex((r) => r?.$id === target);

      const startIndex = this.$refs.virtualList.$_startIndex;
      const endIndex = this.$refs.virtualList.$_endIndex;

      // Using these internal variables is currently the best way to only scroll the list if
      // the item is not in the visible area
      // these are magic numbers that seems to line it up
      if (index
        && !(startIndex === 0 && index < 5)
        && (index <= startIndex + 4 || index > endIndex - 4)
      ) {
        this.$refs.virtualList.scrollToItem(index);
      }
    },
  },
};
